module.exports = __webpack_public_path__ + "static/img/icon_port.acf93842.png";